import { useEffect, useRef, useState } from 'react'
import { BrowserQRCodeReader, type IScannerControls } from '@zxing/browser'

const qrCodePattern = /^[a-fA-F0-9]{64}$/

export function VisitQrScanner({ onCode, onClose }: { onCode: (code: string) => void; onClose: () => void }) {
  const video = useRef<HTMLVideoElement>(null)
  const [error, setError] = useState('')

  useEffect(() => {
    let active = true
    let controls: IScannerControls | null = null
    const reader = new BrowserQRCodeReader()
    const start = async () => {
      try {
        if (!video.current) return
        const scanner = await reader.decodeFromVideoDevice(undefined, video.current, (result, _, currentControls) => {
          if (!active || !result) return
          const code = result.getText().trim()
          if (!qrCodePattern.test(code)) {
            setError('Este QR não é um passe válido da Portaria.')
            return
          }
          active = false
          currentControls.stop()
          onCode(code)
        })
        controls = scanner
        if (!active) scanner.stop()
      } catch {
        if (active) setError('Não foi possível abrir a câmera. Confira a permissão do navegador ou digite o código.')
      }
    }
    void start()
    return () => {
      active = false
      controls?.stop()
      video.current?.srcObject && (video.current.srcObject as MediaStream).getTracks().forEach(track => track.stop())
    }
  }, [onCode])

  return <div className="portaria-modal-backdrop"><div className="portaria-modal" role="dialog" aria-modal="true" aria-label="Ler passe QR">
    <h2>Ler passe QR</h2><p>Aponte a câmera para o QR da visita. A leitura registra a entrada uma única vez.</p>
    <video ref={video} className="portaria-qr-video" muted playsInline aria-label="Imagem da câmera para leitura do QR" />
    {error && <div className="portaria-error" role="alert">{error}</div>}
    <div className="portaria-actions"><button type="button" className="portaria-quiet" onClick={onClose}>Fechar câmera</button></div>
  </div></div>
}
